<div class="pop-header">
    Field Summary
</div>
<div class="pop-body">
    <table>
        <thead>
            <tr>
                <th>Field</th>
                <th>Value</th>
                <th>Visibility</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let field of fields">
                <td>{{field.name}}</td>
                <td>{{field.value}}</td>
                <td class="visibility">
                    <ng-containe [ngSwitch]="field.visibility">
                        <ng-container *ngSwitchCase="visibility.VISIBLE">
                            <nb-icon class="toggle-icon" icon="eye-outline" pack="eva">Visible</nb-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="visibility.HIDDEN">
                            <nb-icon class="toggle-icon" icon="eye-off-outline" pack="eva">Hidden</nb-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="visibility.HIDDEN_ON_MOBILE">
                            <nb-icon class="toggle-icon" icon="smartphone-outline" pack="eva">Mobile</nb-icon>
                            <nb-icon class="toggle-icon" icon="eye-off-outline" pack="eva">Hidden On Mobile</nb-icon>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <nb-icon class="toggle-icon" icon="eye-outline" pack="eva">Visible</nb-icon>
                        </ng-container>
                    </ng-containe>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<!-- <div class="pop-footer">
    <button nbButton status="primary" size="tiny" (click)="onSubmit()">Submit</button>
    <div class="close-message hide" #closeMessage>Click anywhere outside to close</div>
</div> -->
